document.addEventListener('DOMContentLoaded', function () {
  const menu = document.querySelector('[data-mobile-mega-menu]');
  if (!menu) return;

  const listView = menu.querySelector('[data-mobile-menu-list]');
  const drilldowns = menu.querySelectorAll('[data-mobile-menu-drilldown]');

  if (!listView || !drilldowns.length) return;

  function showPanel(drilldown, index) {
    drilldown.querySelectorAll('[data-mobile-menu-rail-trigger]').forEach((item) => {
      item.classList.toggle(
        'mobile-mega-menu__rail-item--active',
        item.dataset.mobileMenuRailTrigger === String(index)
      );
    });

    drilldown.querySelectorAll('[data-mobile-menu-panel]').forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.mobileMenuPanel !== String(index));
    });
  }

  function openDrilldown(index) {
    listView.classList.remove('mobile-mega-menu__screen--active');
    drilldowns.forEach((drilldown) => {
      const isTarget = drilldown.dataset.mobileMenuDrilldown === String(index);
      drilldown.classList.toggle('mobile-mega-menu__screen--active', isTarget);
    });
  }

  function resetToList() {
    drilldowns.forEach((drilldown) => {
      drilldown.classList.remove('mobile-mega-menu__screen--active');
    });
    listView.classList.add('mobile-mega-menu__screen--active');
  }

  menu.addEventListener('click', function (event) {
    if (event.target.closest('.mobile-mega-menu__row-link')) {
      return;
    }

    const trigger = event.target.closest('[data-mobile-menu-trigger]');
    if (trigger) {
      event.preventDefault();
      openDrilldown(trigger.dataset.mobileMenuTrigger);
      return;
    }

    const railTrigger = event.target.closest('[data-mobile-menu-rail-trigger]');
    if (railTrigger) {
      const drilldown = railTrigger.closest('[data-mobile-menu-drilldown]');
      if (drilldown) {
        showPanel(drilldown, railTrigger.dataset.mobileMenuRailTrigger);
      }
      return;
    }

    if (event.target.closest('[data-mobile-menu-back]')) {
      resetToList();
      return;
    }

    if (event.target.closest('[data-mobile-menu-close-link]')) {
      window.toggleMobileMenu?.();
    }
  });

  menu.addEventListener('mobilemenu:reset', resetToList);
});
